var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    stroke: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3214 23.6629L32.4945 17.4898C32.8352 17.1491 32.8352 16.5962 32.4945 16.2555C32.1539 15.9148 31.6009 15.9148 31.2603 16.2555L25.0872 22.4286L19.0782 16.4196C18.7375 16.079 18.1846 16.079 17.8439 16.4196C17.5033 16.7603 17.5033 17.3133 17.8439 17.6539L23.8529 23.6629L17.6832 29.8325C17.3426 30.1732 17.3426 30.7261 17.6832 31.0668C18.0239 31.4075 18.5768 31.4075 18.9175 31.0668L25.0872 24.8971L31.4209 31.2309C31.7616 31.5716 32.3146 31.5716 32.6552 31.2309C32.9959 30.8903 32.9959 30.3373 32.6552 29.9967L26.3214 23.6629Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bb2603a1f19430cc17ffcd45b6a88dfa.svg";
export { ForwardRef as ReactComponent };